<template>
  <el-card
    v-show="visible"
    ref="card"
    v-loading="saving"
    class="modifiable-vessel-dialog"
    :style="style"
  >
    <div slot="header" class="modifiable-vessel-dialog_header">
      <span style="font-size: 16px">{{
        modify ? `修改 ${form.mmsi}` : '添加'
      }}</span>

      <el-button
        type="text"
        icon="el-icon-close"
        style="float: right"
        @click="$emit('update:visible', false)"
      />
    </div>

    <el-form
      ref="form"
      size="mini"
      :model="form"
      :rules="rules"
      label-width="80px"
    >
      <el-row :gutter="3">
        <el-col :span="12" style="margin-right: 0">
          <el-form-item label="mmsi" prop="mmsi">
            <el-input
              v-model="form.mmsi"
              maxlength="9"
              placeholder="mmsi"
              :disabled="modify"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-right: 0">
          <el-form-item label="imo" prop="imo">
            <el-input
              v-model="form.imo"
              placeholder="imo"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="3">
        <el-col :span="12" style="margin-right: 0">
          <el-form-item label="船名" prop="nameEn">
            <el-input
              v-model="form.nameEn"
              maxlength="100"
              placeholder="船名"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-right: 0">
          <el-form-item label="运营方" prop="shipOwnerCn">
            <el-select
              v-model="form.shipOwnerCn"
              filterable
              clearable
              remote
              placeholder="运营方"
              :remote-method="remoteShipping"
              :loading="remoteing"
              style="width: 100%"
              @focus="() => remoteShipping()"
            >
              <el-option
                v-for="ship of shippings"
                :key="ship.code"
                :value="ship.code"
              >
                {{ ship.nameScn }}({{ ship.code }})
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="3">
        <el-col :span="12" style="margin-right: 0">
          <el-form-item label="类别" prop="category">
            <el-select v-model="form.category" clearable style="width: 100%">
              <el-option
                v-for="c of categories"
                :key="c.id"
                :value="c.id"
                :label="c.value"
              >
                {{ c.value }}
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-right: 0">
          <el-form-item label="状态" prop="state">
            <el-select v-model="form.state" style="width: 100%">
              <el-option
                v-for="c of states"
                :key="c.id"
                :value="c.id"
                :label="c.value"
              >
                {{ c.value }}
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button @click="close">关闭</el-button>
        <el-button type="primary" :loading="saving" @click="save">
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { nextIndex } from './utils'
export default {
  props: {
    inf: {
      type: Object,
      default: () => ({}),
    },

    modify: {
      type: Boolean,
      default: false,
    },

    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const validateMmsi = (rule, value, callback) => {
      if (!/^\d{9}$/.test(value)) {
        callback(new Error('mmsi格式错误'))
      } else {
        callback()
      }
    }

    const rules = {
      mmsi: [
        {
          required: true,
          message: '请输入mmsi',
          trigger: 'blur',
        },
        {
          validator: validateMmsi,
          trigger: 'blur',
        },
      ],

      nameEn: [
        {
          required: true,
          message: '请输入船名',
          trigger: 'blur',
        },
      ],
    }

    return {
      form: {
        mmsi: '',
        imo: '',
        nameEn: '',
        shipOwnerCn: '',
        category: '',
        state: 1,
      },

      remoteing: false,
      shippings: [],

      categories: [
        {
          id: 1,
          value: '驳船',
        },
        {
          id: 2,
          value: '国际集装箱船',
        },
      ],

      states: [
        {
          id: 0,
          value: '无效',
        },
        {
          id: 1,
          value: '有效',
        },
      ],

      rules,

      saving: false,

      graping: false,

      point: {
        x: 350,
        y: 200,
        x1: 400,
        y1: 200,
        zIndex: nextIndex(),
      },
    }
  },

  computed: {
    style() {
      return {
        left: (this.graping ? this.point.x1 : this.point.x) + 'px',
        top: (this.graping ? this.point.y1 : this.point.y) + 'px',
        transition: this.graping ? 'none' : 'left .5s, top .5s',
        'z-index': this.point.zIndex,
      }
    },
  },

  watch: {
    inf: {
      handler() {
        Object.keys(this.form).forEach(key => {
          this.$set(this.form, key, this.inf[key])
        })

        if (typeof this.form.state !== 'number') {
          this.form.state = 1
        }
      },
    },

    visible(val) {
      if (val) {
        document.body.appendChild(this.$el)
      }
    },
  },

  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },

  beforeDestroy() {
    this.$emit('destroy')
  },

  created() {
    const point = {
      x: 0,
      y: 0,
    }

    const onheadermove = event => {
      if (this.graping) {
        this.point.x1 = this.point.x + (event.pageX - point.x)
        this.point.y1 = this.point.y + (event.pageY - point.y)
      }
    }

    const onheaderup = () => {
      this.graping = false
      this.point.x = Math.min(
        Math.max(10, this.point.x1),
        window.innerWidth - 80
      )
      this.point.y = Math.min(
        Math.max(10, this.point.y1),
        window.innerHeight - 80
      )
      document.removeEventListener('mousemove', onheadermove)
      document.removeEventListener('mouseup', onheaderup)
    }

    this.onheaderdown = event => {
      this.graping = true
      point.x = event.pageX
      point.y = event.pageY
      this.point.zIndex = nextIndex()

      document.addEventListener('mousemove', onheadermove)
      document.addEventListener('mouseup', onheaderup)
    }
  },

  mounted() {
    const header = this.$refs.card.$el.querySelector('.el-card__header')
    header.addEventListener('mousedown', this.onheaderdown)
    this.$on('destroy', () =>
      header.removeEventListener('mousedown', this.onheaderdown)
    )
  },

  methods: {
    async remoteShipping(content) {
      this.remoteing = true
      try {
        const resp = await this.$axios.get(
          this.commonJs.localUrl + `/schedules/baseVessel/queryShipping`,
          {
            params: {
              content: content || '',
            },
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        this.shippings = resp.data.content || []
      } finally {
        this.remoteing = false
      }
    },
    close() {
      this.$emit('close')
    },

    async save() {
      this.saving = true
      try {
        await this.$refs.form.validate()

        const body = Object.assign({}, this.form, {
          id: this.inf.id,
        })

        if (typeof body.category !== 'number') {
          body.category = 0
        }
        console.log(body)
        const resp = await this.$axios.post(
          this.commonJs.localUrl +
            `/schedules/modifiableVessel/${this.modify ? 'modify' : 'append'}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )

        if (resp.data.status !== 1) {
          this.$message.error(resp.data.message || '失败')
        } else {
          this.$emit('successful')
        }
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modifiable-vessel-dialog {
  border: none;
  position: fixed;

  .modifiable-vessel-dialog_header {
    cursor: all-scroll;
    user-select: none;
  }
}
</style>
